import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalMensagemBancoComponent } from '../modal-mensagem-banco/modal-mensagem-banco.component';
import { MensagemBanco } from '../_classes/mensagem-banco';

@Injectable({
  providedIn: 'root'
})
export class ModalMensagemBancoService {
  constructor(private modalService: BsModalService) {}

  mostrar(mensagemBanco: MensagemBanco[]) {
    const bsModalRef: BsModalRef = this.modalService.show(
      ModalMensagemBancoComponent,
      Object.assign({}, { class: 'max-content' })
    );
    bsModalRef.setClass('max-content');
    bsModalRef.content.msg = mensagemBanco;
    bsModalRef.content.modal = bsModalRef;
    bsModalRef.content.ativar();
  }
}
